import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/agreements`;

export async function downloadAgreementAPI(agreementNumber) {
  return getRequest(`${url}/${agreementNumber}`, await authorize());
}
